import { FinancingOptionDataSourceEnum } from '@inter-ikea-kompis/enums';
import { PriceUtility, TotalPriceCalculator } from '@inter-ikea-kompis/utilities';
import OneWebFinancingService from '../../services/financing/OneWebFinancingService.js';
import DexfConfiguration from '../../utilities/DexfConfiguration.js';
/**
 * Financing service used to fetch a financing option for a customer's solution.
 */
export default class FinancingService {
    /**
     * Constructor.
     *
     * @param options IFinancingServiceOptions.
     */
    constructor(options) {
        this.dexfConfiguration = new DexfConfiguration(options);
    }
    /**
     * Fetches and returns financial services data.
     *
     * @param shoppingProducts The shopping products of the current solution.
     * @returns Promise of financing option, or null if not supported by the market.
     * @throws Different errors if fetching financing option fails in some way (see {@link OneWebFinancingService.getFinancingOption}).
     */
    async getFinancingOption(shoppingProducts) {
        const settings = await this.dexfConfiguration.getSettings();
        if (settings.kompis.serviceSettings.financingOptionDataSource ===
            FinancingOptionDataSourceEnum.disabled) {
            return null;
        }
        const price = TotalPriceCalculator.calculate(shoppingProducts, settings.localisation.dateFormat);
        return await new OneWebFinancingService().getFinancingOption(settings.kompis.endpoints.oneWebFinancingService, settings.kompis.endpoints.oneWebFinancingServiceFragmentBaseUrl ?? '', PriceUtility.getPrice(price));
    }
}
//# sourceMappingURL=FinancingService.js.map